const taxTypeId = (content: string): string => {
  return content.replace(/[ .:]/g, '');
};
export default taxTypeId;
